import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import WaiverPreview from "../commoncomponents/WaiverPreview";

const WaiverSignerPreview = () => {

  const { waiver } = useOutletContext();  
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const { waiverId } = useParams();

  const [waiverData, setWaiverData] = useState(null);  
  const [loading, setLoading] = useState(true);

  const [signerType, setSignerType] = useState("adult");
  const [waiverMode, setWaiverMode] = useState("full"); // "full" | "quick"
  const [device, setDevice] = useState("desktop");

  const [governingData, setGoverningData] = useState([]);
  
  const isPublished = waiverData?.waiver?.waiverStatus === "published"; //React re-renders when state updates (waiverData), so it will automatically recompute on every render. 
  
  const isArchived =
  waiverData?.waiver?.waiverStatus === "archived_by_admin" ||
  waiverData?.waiver?.waiverStatus === "archived_by_new_version" ||
  waiverData?.waiver?.waiverStatus === "archived_by_location_deletion" ;

  const [waiverHolder, setWaiver] = useState(null); 

  const [showPublishConfirm, setShowPublishConfirm] = useState(false);

  const [otherMap, setOtherMap] = useState({}); 
  // { questionId: "text entered" }

  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}?mode=preview`, {
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        });

        const data = await res.json();

        if (data.success) {
          setWaiverData(data);
          setWaiver(data.waiver);
          
        }
      } catch (err) {
        console.error("Failed loading waiver", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [business, waiverId, navigate]);

  /* useEffect for Governing Law (same logic as Step-6)*/
  useEffect(() => {
    if (!waiverData?.waiver?.locations?.length) return;

    const loadGoverningLaws = async () => {
      try {
        // get all business locations
        const locRes = await fetch(API_URL.BUSINESS_LOCATIONS, {
          headers: {
            Authorization: `Bearer ${business.token}`,
          },
        });

        const locJson = await locRes.json();

        // only waiver locations
        /*const locations = locJson.locations.filter(loc =>
          waiverData.waiver.locations.includes(loc._id)
        );*/
        
        const waiverLocationIds = waiverData.waiver.locations.map(l =>
          String(typeof l === "string" ? l : l._id)
        );

        const locations = locJson.locations.filter(loc =>
          waiverLocationIds.includes(String(loc._id))
        );

        // unique states
        const states = [...new Set(locations.map(l => l.state))];

        // fetch waiver-specific clauses
        const clauseRes = await fetch(
          `${API_URL.GET_STATE_CLAUSES_FOR_WAIVER}/${waiverData.waiver._id}?states=${states.join(",")}`,
          {
            headers: {
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,
              "x-frontend-url": window.location.pathname,
            },
          }
        );

        const clauseJson = await clauseRes.json();

        // map per location
        const uiData = locations.map(loc => ({
          locationName: loc.name,
          state: loc.state,
          clause:
            clauseJson.data.find(
              c =>
                c.state.trim().toLowerCase() ===
                loc.state.trim().toLowerCase()
            )?.body ||
            "<p>No governing law found for this state.</p>",
        }));

        setGoverningData(uiData);
      } catch (err) {
        console.error("Failed loading governing laws (preview)", err);
      }
    };

    loadGoverningLaws();
  }, [waiverData, business.token]);

  /* Detect if any option text is exactly "other" (after waiverData loads).  Multiple questions may have other option. */
  useEffect(() => {
    if (!waiverData) return;

    const map = {};

    waiverData.waiver.questions?.forEach(q => {
      const hasOther = (q.options || []).some(
        opt => opt?.label?.trim().toLowerCase() === "other"
      );

      if (hasOther) {
        map[q._id] = ""; // initialize empty
      }
    });

    setOtherMap(map);
  }, [waiverData]);


  const handleSignerChange = (type) => {
    if (type === "minor" && !waiverData?.waiver?.minorWaiverAllowed) {
      alert("Minor waiver is not allowed for this template");
      return;
    }
    setSignerType(type);
  };

  const handleModeChange = (mode) => {
    if (
      mode === "quick" &&
      waiverData?.waiver?.returningSignerPolicy?.toLowerCase() !== "quick_resign"
    ) {
      alert("Quick resign is not enabled for this waiver");
      return;
    }

    setWaiverMode(mode);
  };

  if (loading) {
    return (
      <div className="p-8">
        <div>Loading...</div>
      </div>
    );
  }

  const businessName = waiverData?.waiver?.businessId?.businessName || "";
  const businessEmail = waiverData?.waiver?.businessId?.email || "";
  const county =  waiverData?.waiver?.locations?.[0]?.county || "";

  const phValues = {
    BUSINESS_NAME: businessName,
    BUSINESS_EMAIL: businessEmail,
    COUNTY: county,
    MINOR_FULL_NAME: "the minor",
    MINOR_FIRST_NAME: "the minor",
    PREVIOUS_SIGNED_DATE: "THE PREVIOUS SIGNED DATE",
  };

  return (
    <>    
    <div className="p-8">
      <h2 className="text-2xl font-semibold mb-6">
        Signer Preview
      </h2>

                  
         

        {/* PREVIEW */}
        <div className="flex justify-center">
        
        <WaiverPreview
            key={`${signerType}_${waiverMode}`}  // ✅ FORCE REMOUNT if any of these 2 are changed
            waiverData={waiverData}
            signerType={signerType}
            device={device}
            waiverMode={waiverMode}
            governingData={governingData}
            phValues={phValues}
            otherMap={otherMap}
            setOtherMap={setOtherMap}
        />
            
        </div>
        

    </div>
      
    </>
  );
};

export default WaiverSignerPreview;